import { initErrorReporter } from "@kaggle/components";
import { bootstrapJupyterLabSessionlessEditor } from "./bootstrapJupyterLabSessionlessEditor";

initErrorReporter(/* versionModifier= */ "sessionless");
bootstrapJupyterLabSessionlessEditor();
